import React from 'react';
import './Legal.css';

function LegalPage({ title, lastUpdated, sections }) {
  return (
    <div className="legal">
      <section className="legal-hero">
        <div className="container">
          <div className="legal-hero__content">
            <div className="section-tag">Legal</div>
            <h1 className="section-title">{title}</h1>
            <p className="legal-date">Last updated: {lastUpdated}</p>
          </div>
        </div>
      </section>
      <section className="legal-content">
        <div className="container">
          <div className="legal-body">
            {sections.map((s, i) => (
              <div key={i} className="legal-section">
                <h2>{s.title}</h2>
                {Array.isArray(s.content) ? (
                  <ul>{s.content.map((item, j) => <li key={j}>{item}</li>)}</ul>
                ) : (
                  <p>{s.content}</p>
                )}
              </div>
            ))}
            <div className="legal-contact">
              <p>For questions, contact us at: <a href="mailto:halo@msdiscoveries.com">halo@msdiscoveries.com</a> or call <a href="tel:+919443724724">+91 9443724724</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export function Privacy() {
  return <LegalPage
    title="Privacy Policy"
    lastUpdated="January 2024"
    sections={[
      { title: '1. Information We Collect', content: 'We collect information you provide directly to us, such as when you create an account, fill out a form, or contact us. This may include your name, email address, phone number, and business information.' },
      { title: '2. How We Use Your Information', content: ['To provide and improve our services', 'To communicate with you about your account', 'To send marketing communications (with your consent)', 'To comply with legal obligations'] },
      { title: '3. Data Security', content: 'We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.' },
      { title: '4. Data Sharing', content: 'We do not sell, trade, or share your personal information with third parties without your explicit consent, except as required by law or as necessary to provide our services.' },
      { title: '5. Cookies', content: 'We use cookies and similar tracking technologies to improve your experience on our platform. You can control cookie settings through your browser settings.' },
      { title: '6. Your Rights', content: ['Access your personal data', 'Correct inaccurate data', 'Request deletion of your data', 'Opt-out of marketing communications'] },
      { title: '7. Changes to This Policy', content: 'We may update this privacy policy from time to time. We will notify you of any significant changes by email or through our platform.' },
    ]}
  />;
}

export function Terms() {
  return <LegalPage
    title="Terms & Conditions"
    lastUpdated="January 2024"
    sections={[
      { title: '1. Acceptance of Terms', content: 'By accessing or using the MS Discoveries platform and services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.' },
      { title: '2. Use of Services', content: ['You must be at least 18 years old to use our services', 'You agree to provide accurate and complete information', 'You are responsible for maintaining the security of your account', 'You agree not to misuse our services or interfere with other users'] },
      { title: '3. Intellectual Property', content: 'All content, features, and functionality on the MS Discoveries platform are owned by MS Discoveries and are protected by intellectual property laws.' },
      { title: '4. Payment Terms', content: 'Subscription fees are billed in advance. All fees are non-refundable except as specified in our Refund Policy. We reserve the right to change pricing with reasonable notice.' },
      { title: '5. Service Availability', content: 'We strive to maintain 99%+ uptime but do not guarantee uninterrupted access to our services. We are not liable for any damages resulting from service interruptions.' },
      { title: '6. Limitation of Liability', content: 'MS Discoveries shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.' },
      { title: '7. Termination', content: 'We reserve the right to suspend or terminate your account if you violate these Terms. You may cancel your account at any time from your dashboard settings.' },
      { title: '8. Governing Law', content: 'These Terms are governed by the laws of India. Any disputes shall be resolved under the jurisdiction of courts in Tamil Nadu, India.' },
    ]}
  />;
}

export function Refund() {
  return <LegalPage
    title="Refund Policy"
    lastUpdated="January 2024"
    sections={[
      { title: '1. Free Trial', content: 'We offer a free trial period for new users. No payment is required during the trial. You can explore all features before subscribing.' },
      { title: '2. Refund Eligibility', content: ['Refund requests must be made within 7 days of initial payment', 'Technical issues preventing service use that we cannot resolve', 'Billing errors or duplicate charges', 'Requests made after 7 days will generally not be eligible'] },
      { title: '3. Non-Refundable Items', content: ['Subscription fees for completed billing periods', 'Setup or onboarding fees', 'Add-on services already consumed', 'Fees for accounts suspended due to policy violations'] },
      { title: '4. How to Request a Refund', content: 'To request a refund, contact us at halo@msdiscoveries.com with your order details and reason for the refund. We will process valid requests within 5-7 business days.' },
      { title: '5. Processing Time', content: 'Approved refunds will be credited back to your original payment method within 5-10 business days, depending on your bank or payment provider.' },
      { title: '6. Cancellations', content: 'You can cancel your subscription at any time. Cancellation will take effect at the end of the current billing period. You will continue to have access until then.' },
    ]}
  />;
}

export default Privacy;
